var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3984 30.5601H24.5768L17.3391 19.0882V30.5601H14.5176V14.3906H17.3391L24.5992 25.9069V14.3906H27.3984V30.5601Z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5101 30.5601H33.7695V14.3906H36.5101V30.5601Z",
    fill: "#28C0E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5101 55.5679H33.7695V39.3984H36.5101V55.5679Z",
    fill: "#FDFDFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4897 16.6561H50.5074V30.5601H47.7529V16.6561H42.8145V14.3906H55.4897V16.6561Z",
    fill: "#28C0E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4933 49.3378H17.3435V55.5679H14.5176V39.3984H20.2364C22.1129 39.3984 23.5612 39.8167 24.5813 40.6533C25.6015 41.49 26.1115 42.7004 26.1115 44.2848C26.1115 45.3657 25.8472 46.2727 25.3185 47.0056C24.7973 47.7312 24.0675 48.2902 23.1293 48.6826L26.7817 55.4235V55.5679H23.7548L20.4933 49.3378ZM17.3435 47.0834H20.2475C21.2007 47.0834 21.9453 46.8465 22.4814 46.3726C23.0176 45.8914 23.2857 45.2362 23.2857 44.407C23.2857 43.5408 23.0362 42.8707 22.5373 42.3969C22.0458 41.9231 21.3086 41.6787 20.3257 41.6639H17.3435V47.0834Z",
    fill: "#FDFDFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.946 45.2399L52.3425 39.3984H55.5837L50.6997 47.4165L55.6947 55.5679H52.4202L48.946 49.6376L45.4606 55.5679H42.1973L47.2033 47.4165L42.3083 39.3984H45.5494L48.946 45.2399Z",
    fill: "#FDFDFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H28V2.78014H2.78014V28H0V0Z",
    fill: "#FDFDFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 0H42V2.78014H67.2199V28H70V0Z",
    fill: "#FDFDFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 70H42V67.2199H67.2199V42H70V70Z",
    fill: "#FDFDFD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 70H28V67.2199H2.78014V42H0V70Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLite);
export default __webpack_public_path__ + "static/media/logo_lite.13c39fa449ae3a5705dc90f7a09c318d.svg";
export { ForwardRef as ReactComponent };